import { render, staticRenderFns } from "./ToylandBanner.vue?vue&type=template&id=b499a3ec"
import script from "./ToylandBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToylandBanner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ToylandBanner.vue?vue&type=style&index=0&id=b499a3ec&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports